export default {
    state: {
        searchMode: false,
    },
    getters: {},
    mutations: {
        setRecycleStatus(state, obj) {
            let key = Object.keys(obj);
            for (let item of key) {
                state[item] = obj[item];
            }
        },
    },
};
